export const SURVEY_ON_OFF = 'ON_OFF';
export const SURVEY_ON_OFF_LEGACY = 'ON-OFF';
export const SURVEY_DEPOL = 'DEPOL';
export const SURVEY_ON = 'ON';
export const SURVEY_NATIVE = 'NATIVE';
export const SURVEY_DOC = 'DOC';
export const SURVEY_REL = 'REL';
export const SURVEY_DCVG = 'DCVG';
export const SURVEY_ACCA = 'ACCA';
export const SURVEY_ACVG = 'ACVG';
export const SURVEY_UNKNOWN = 'UNKNOWN';
export const SURVEY_ACPSP = 'ACPSP';
export const SURVEY_PROFILE = 'PROFILE';
export const SURVEY_REPORTED_ANOMALIES = 'REPORTED_ANOMALIES';

export const KNOWN_SURVEYS = [
	SURVEY_ON_OFF,
	SURVEY_DEPOL,
	SURVEY_ON,
	SURVEY_NATIVE,
	SURVEY_ACVG,
	SURVEY_DCVG,
	SURVEY_ACCA,
	SURVEY_DOC,
	SURVEY_REL,
	SURVEY_ACPSP,
	SURVEY_PROFILE,
	SURVEY_REPORTED_ANOMALIES,
];
export const SURVEY_PRIORITY = [
	SURVEY_ON_OFF,
	SURVEY_ON_OFF_LEGACY,
	SURVEY_ON,
	SURVEY_DEPOL,
	SURVEY_NATIVE,
	SURVEY_REPORTED_ANOMALIES,
	SURVEY_ACVG,
	SURVEY_DCVG,
	SURVEY_ACCA,
	SURVEY_DOC,
	SURVEY_REL,
	SURVEY_ACPSP,
	SURVEY_PROFILE,
];

// @note-supported-constant-needs-abstraction
